<!-- Body Content-->
<div [attr.data-testid]="'transaction-tab-container'">
  <!-- Before Payment Button Click -->
  @if (!transactionEnable) {
    <div [attr.data-testid]="'before-payment-section'">
      <!-- Payment Methods-->
      <div
        class="p-2 font-bold flex align-items-center justify-content-between border-bottom-1 border-300 pb-2 mb-2"
      >
        <div
          class="text-xs md:text-sm"
          [attr.data-testid]="'transaction-title'"
        >
          {{ 'TRANSACTION.TITLE' | translate }}
        </div>
        <button
          type="button"
          pButton
          pRipple
          [label]="'TRANSACTION.PAYMENT_BTN_LABEL' | translate"
          icon=""
          class="text-xs md:text-sm"
          (click)="showPaymentMethod(true)"
          [attr.aria-label]="'show-payment-methods-button'"
          [attr.data-testid]="'show-payment-methods-button'"
        ></button>
      </div>
      <!-- Payment Methods -->
      <!-- Card-->
      <div class="px-2 text-sm" [attr.data-testid]="'transaction-tabs'">
        <ul class="list-none px-2 surface-0 m-0">
          <!-- Invoice -->
          <li
            class="py-2 border-bottom-1 border-300"
            [attr.data-testid]="'invoice-tab'"
          >
            <invoice-tab
              [clientId]="clientId()"
              [tenantId]="tenantId"
              (tabAction)="handleTabAction($event)"
            />
          </li>
          <!-- Invoice -->
          <!-- Payments -->
          <li
            class="py-2 border-bottom-1 border-300"
            [attr.data-testid]="'payment-tab'"
          >
            <payment-tab
              [clientId]="clientId()"
              [tenantId]="tenantId"
              (tabAction)="handleTabAction($event)"
              (updateData)="handleUpdateData($event)"
            />
          </li>
          <!-- Payments -->
          <!-- Sales Return -->
          @if (showSalesReturn | async) {
            <li
              class="py-2 border-bottom-1 border-300"
              [attr.data-testid]="'sales-return-tab'"
            >
              <sales-return-tab [clientId]="clientId()" [tenantId]="tenantId" />
            </li>
          }
          <!-- Sales Return -->
          <!-- Refund -->
          @if (showRefund | async) {
            <li
              class="py-2 border-bottom-1 border-300"
              [attr.data-testid]="'refund-tab'"
            >
              <refund-tab [clientId]="clientId()" [tenantId]="tenantId" />
            </li>
          }
          <!-- Refund-->
          <!-- Retail Products -->
          @if (showRetail | async) {
            <li
              class="py-2 border-bottom-1 border-300"
              [attr.data-testid]="'retail-products-tab'"
            >
              <lib-retail-products-tab
                [clientId]="clientId()"
                [tenantId]="tenantId"
              />
            </li>
          }
          <!-- Retail Products -->
          <!-- Freeze -->
          <li
            class="py-2 border-bottom-1 border-300"
            [attr.data-testid]="'freeze-tab'"
          >
            <lib-freeze-list-tab
              [clientId]="clientId()"
              [tenantId]="tenantId"
              [activeSubTab]="activeSubTab()"
              (isUpdated)="handleFreezeUpdateData($event)"
            />
          </li>
          <!-- Freeze -->
          <!-- Guest Pass -->
          <li
            class="py-2 border-bottom-1 border-300"
            [attr.data-testid]="'guest-pass-tab'"
          >
            <guest-pass-list-tab
              [clientId]="clientId()"
              [tenantId]="tenantId"
              [showHeader]="true"
            />
          </li>
          <!-- Guest Pass -->
        </ul>
      </div>
      <!-- Card -->
    </div>
  } @else {
    <!-- After Payment Button Click -->
    <div [attr.data-testid]="'payment-methods-section'">
      <!-- Add New Card -->
      <div
        class="surface-0 border-1 border-300 shadow-1 border-round font-bold flex align-items-center justify-content-between"
      >
        <div class="flex align-items-center">
          <div
            class="cursor-pointer text-primary border-right-1 border-300 py-2 px-2 md:p-3 mr-2 md:mr-3"
            (click)="showPaymentMethod(false)"
            [attr.aria-label]="'back-button'"
            [attr.data-testid]="'back-button'"
          >
            <i class="fa fa-chevron-left md:mr-2"></i>
            <span class="hidden md:inline">{{
              'TRANSACTION.BACK' | translate
            }}</span>
          </div>
          <div
            class="my-1 text-xs md:text-sm"
            [attr.data-testid]="'payment-methods-count'"
          >
            {{ 'TRANSACTION.PAYMENT_METHODS' | translate }} -
            <strong> {{ (paymentMethods$ | async).length | number }} </strong>
          </div>
        </div>
        <div class="py-1 px-2 md:p-2">
          <!-- <button type="button" pButton pRipple [label]="'TRANSACTION.ADD_NEW_CARD' | translate"
        icon="fa fa-plus" class="text-xs md:text-sm hidden md:inline-block"
      (click)="showPopUpForNewCard = true"></button>
      <button pButton pRipple type="button" icon="fa fa-plus" class="text-sm md:hidden h-2rem w-2rem"
      (click)="showPopUpForNewCard = true"></button> -->
        </div>
      </div>
      <!-- Add New Card -->
      <!-- Card -->
      <!-- No Payment Methods -->
      @if ((paymentMethods$ | async)?.length === 0) {
        <div
          class="surface-0 border-1 border-300 shadow-1 border-round py-5 text-sm mt-3 text-center"
          [attr.data-testid]="'no-payment-methods'"
        >
          <i class="pi pi-wallet text-4xl text-400 mb-3"></i>
          <p class="text-600 mb-0 font-medium">
            {{ 'PAYMENT.PAYMENT_METHODS.NO_PAYMENT_METHODS' | translate }}
          </p>
        </div>
      }
      <!-- Payment Methods List -->
      @if ((paymentMethods$ | async)?.length > 0) {
        <div
          class="surface-0 border-1 border-300 shadow-1 border-round py-2 text-sm mt-3"
          [attr.data-testid]="'payment-cards-list'"
        >
          @for (
            payment of paymentMethods$ | async;
            track payment;
            let i = $index
          ) {
            <ul class="list-none p-0 m-0">
              <li
                class="py-3 px-3 md:px-4 border-bottom-1 border-300 flex align-items-start justify-content-between"
                [attr.data-testid]="'payment-card-' + i"
              >
                <div class="flex align-items-start">
                  <img
                    width="50"
                    [src]="getPaymentMethodDetails(payment).img"
                    [alt]="getPaymentMethodDetails(payment).level1Text"
                    [attr.data-testid]="'card-logo-' + i"
                  />
                  <div class="ml-2">
                    <h4
                      class="text-base md:text-lg mb-1 line-height-1 font-bold"
                      [attr.data-testid]="'card-number-' + i"
                    >
                      {{ getPaymentMethodDetails(payment).level1Text }}
                      @if (payment.network_type) {
                        <span>{{ payment.network_type }}</span>
                      }
                      @if (payment.masked_card_number) {
                        <span
                          >{{ 'PAYMENT.PAYMENT_METHODS.ENDING' | translate }}
                          {{ payment.masked_card_number }}</span
                        >
                      }
                      @if (
                        !payment.masked_card_number &&
                        payment.masked_account_number
                      ) {
                        <span
                          >{{ 'PAYMENT.PAYMENT_METHODS.ENDING' | translate }}
                          {{ payment.masked_account_number }}</span
                        >
                      }
                      @if (payment.vpa_id) {
                        <span>{{ payment.vpa_id }}</span>
                      }
                    </h4>
                    <p
                      class="mb-0 text-xs text-800"
                      [attr.data-testid]="'card-details-' + i"
                    >
                      @if (payment.expiry_date) {
                        <span
                          >{{ 'PAYMENT.PAYMENT_METHODS.EXPIRES' | translate }}
                          {{
                            payment.expiry_date | datetimeformat: 'MM/yy'
                          }}</span
                        >
                      }
                      @if (
                        payment.expiry_date && payment.token_account_holder_name
                      ) {
                        <span> | </span>
                      }
                      @if (payment.token_account_holder_name) {
                        <span>{{ payment.token_account_holder_name }}</span>
                      }
                    </p>
                    @if (
                      payment.expiry_date &&
                      getExpirtDateError(payment.expiry_date)
                    ) {
                      <p-message
                        severity="error"
                        [attr.data-testid]="'expiry-error-' + i"
                      >
                        <div class="-m-2 flex align-items-center">
                          <i class="fa fa-times text-xl-circle mr-2"></i>
                          <span class="custom-message text-xs md:text-sm"
                            >{{
                              'PAYMENT.PAYMENT_METHODS.CARD_EXPIRY_ERROR'
                                | translate
                            }}
                            <strong class="cursor-pointer">{{
                              'PAYMENT.PAYMENT_METHODS.CLICK_HERE' | translate
                            }}</strong>
                            {{ 'PAYMENT.PAYMENT_METHODS.TOUPDATE' | translate }}
                          </span>
                        </div>
                      </p-message>
                    }
                  </div>
                </div>
                <div>
                  <!-- <button pButton pRipple type="button" icon="fa fa-pencil"
              [label]="'SUBSCRIPTION.UPDATE_CARD' | translate"
            class="p-button-outlined text-sm mt-1 hidden md:inline-block"></button>
            <button pButton pRipple type="button" icon="fa fa-pencil"
            class="p-button-outlined text-sm mt-1 md:hidden h-2rem w-2rem"></button> -->
                </div>
              </li>
            </ul>
          }
        </div>
      }
      <!-- Card -->
      <!-- Card -->
    </div>
    <!-- After Payment Button Click -->
  }
</div>
<!-- Body Content-->

<!-- Void Payment Modal -->
<p-dialog
  [visible]="showVoidPaymentModal"
  (onHide)="showVoidPaymentModal = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '630px' }"
  styleClass="no-header-modal"
  [attr.aria-label]="'void-payment-dialog'"
  [attr.data-testid]="'void-payment-dialog'"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <form
      [formGroup]="voidPaymentForm"
      [attr.data-testid]="'void-payment-form'"
    >
      <div class="relative text-center p-4">
        <div
          class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showVoidPaymentModal = false"
          [attr.aria-label]="'close-dialog-button'"
          [attr.data-testid]="'close-dialog-button'"
        ></div>

        <img
          width="160"
          class="block mx-auto"
          src="/assets/img/void-invoice-img.svg"
          alt="Image"
          [attr.data-testid]="'void-payment-image'"
        />

        <h4
          class="text-base md:text-lg my-3 font-bold"
          [attr.data-testid]="'void-payment-title'"
        >
          {{ 'PAYMENT.PAYMENT_DEL_CONFI' | translate }} <br />
          {{ paymentDetails.number_prefix }} ?
        </h4>
        <p
          class="text-600 md:w-26rem mx-auto mb-0"
          [attr.data-testid]="'void-payment-message'"
        >
          {{ 'PAYMENT.PAYMENT_DEL_INFO' | translate }}
        </p>
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label
          for="reason-textarea"
          class="font-medium text-700 text-xs mb-2 block uppercase"
          [attr.data-testid]="'reason-label'"
          >{{ 'PAYMENT.REASON' | translate }}</label
        >
        <textarea
          pInputTextarea
          formControlName="void_reason"
          class="text-sm w-full h-5rem"
          [attr.aria-label]="'reason-textarea'"
          [attr.data-testid]="'reason-textarea'"
        ></textarea>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-secondary p-button-text text-sm"
          (click)="showVoidPaymentModal = false"
          [attr.aria-label]="'cancel-void-payment-button'"
          [attr.data-testid]="'cancel-void-payment-button'"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'PAYMENT.VOID_LABEL' | translate"
          class="p-button-danger text-sm"
          (click)="deletePayment()"
          [attr.aria-label]="'void-transaction-tab-button'"
          [attr.data-testid]="'void-transaction-tab-button'"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Void Payment Modal -->

<!-- Share App Link Modal  -->
<p-dialog
  [visible]="showPopUpForNewCard"
  (onHide)="showPopUpForNewCard = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '991px': '100vw' }"
  [style]="{ width: '900px' }"
  styleClass="no-header-modal"
  [attr.aria-label]="'share-link-dialog'"
  [attr.data-testid]="'share-link-dialog'"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <h2 class="mb-0 text-sm" [attr.data-testid]="'dialog-title'">
        {{ 'PAYMENT.PAYMENT_METHODS.ADD_NEW_CARD_MSG' | translate }}
      </h2>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="showPopUpForNewCard = false"
        [attr.aria-label]="'close-dialog-button'"
        [attr.data-testid]="'close-dialog-button'"
      ></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="flex">
      <!-- Left Side-->
      <div
        class="surface-100 border-right-1 border-300 lg:w-9 w-full flex flex-column justify-content-between"
      >
        <!-- Modal Content -->
        <div
          class="py-3 md:py-5 px-3 md:px-5 flex align-items-center justify-content-center h-full"
        >
          <!-- Grid -->
          <div class="grid w-full">
            <div
              class="col-12 md:col-6"
              (click)="shareLink('sms')"
              [attr.data-testid]="'sms-share-option'"
            >
              <a
                href="javascript:void(0)"
                class="flex align-items-center p-3 surface-0 text-primary border-1 border-primary border-round no-underline font-bold hover:bg-primary hover:text-white"
                [attr.aria-label]="'share-via-sms-button'"
                [attr.data-testid]="'share-via-sms-button'"
              >
                <i class="fa fa-comments font-light mr-2"></i
                ><span>{{
                  'PAYMENT.PAYMENT_METHODS.SAHRE_LINK_SMS' | translate
                }}</span></a
              >
              <p
                class="mb-0 mt-3 text-xs text-600"
                [attr.data-testid]="'sms-share-info'"
              >
                {{ 'PAYMENT.PAYMENT_METHODS.LINK_SHARE_MIN' | translate }}
              </p>
            </div>
            <div
              class="col-12 md:col-6"
              (click)="shareLink('email')"
              [attr.data-testid]="'email-share-option'"
            >
              <a
                href="javascript:void(0)"
                class="flex align-items-center p-3 surface-0 text-primary border-1 border-primary border-round no-underline font-bold hover:bg-primary hover:text-white"
                [attr.aria-label]="'share-via-email-button'"
                [attr.data-testid]="'share-via-email-button'"
              >
                <i class="fa fa-envelope font-light mr-2"></i
                ><span>{{
                  'PAYMENT.PAYMENT_METHODS.SAHRE_LINK_EMAIL' | translate
                }}</span></a
              >
            </div>
          </div>
          <!-- Grid -->
        </div>
        <!-- Modal Content -->
      </div>
      <!-- Left Side -->

      <!-- Right Side -->
      <div
        class="pl-3 w-3 hidden lg:flex align-items-center justify-content-center p-3 text-right"
      >
        <img
          width="180"
          src="/assets/img/share-link-img.svg"
          alt="Image"
          [attr.data-testid]="'share-link-image'"
        />
      </div>
      <!-- Right Side -->
    </div>
    <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Share App Link Modal -->
